import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      components: {
        default: () => import('./views/Home'),
        non_authenticated: () => import('./views/NonAuthenicated/Landing')
      }
    },
    {
      path: '/login',
      name: 'Login',
      components: {
        non_authenticated: () => import('./views/NonAuthenicated/Login')
      }
    },
    {
      path: '/non_auth/day',
      name: 'NonAuthDaySchedule',
      components: {
        non_authenticated: () => import('./views/NonAuthenicated/Schedule/DaySchedule')
      }
    },
    {
      path: 'license',
      name: 'License',
      component: () => import('./views/License')
    },
    {
      path: '/alert/dashboard',
      name: 'AlertDashboard',
      component: () => import('./views/Alert/Dashboard')
    },
    {
      path: '/scheduler',
      component: () => import('./views/Scheduler/Index'),
      children: [
        {
          path: 'day',
          name: 'DayScheduler',
          component: () => import('./views/Scheduler/Day/Index')
        },
        {
          path: 'day/add',
          name: 'AddDaySchedule',
          component: () => import('./views/Scheduler/Day/AddDaySchedule')
        },
        {
          path: 'day/edit/:day_schedule_id',
          name: 'EditDaySchedule',
          props: true,
          component: () => import('./views/Scheduler/Day/EditDaySchedule')
        },
        {
          path: 'day/copy/:day_schedule_id_to_copy',
          name: 'CopyDaySchedule',
          props: true,
          component: () => import('./views/Scheduler/Day/CopyDaySchedule')
        },
        {
          path: 'day/item/add/:day_schedule_id',
          name: 'AddDayScheduleItem',
          props: true,
          component: () => import('./views/Scheduler/Day/AddDayScheduleItem')
        },
        {
          path: 'day/item/edit/:day_schedule_item_id',
          name: 'EditDayScheduleItem',
          props: true,
          component: () => import('./views/Scheduler/Day/EditDayScheduleItem')
        },
        {
          path: 'day/item/add_interval/:day_schedule_id',
          name: 'AddDayScheduleItemAtInterval',
          props: true,
          component: () => import('./views/Scheduler/Day/AddDayScheduleItemAtInterval')
        },
        {
          path: 'day/item/copy/:day_schedule_id',
          name: 'CopyDayScheduleItemsZone',
          props: true,
          component: () => import('./views/Scheduler/Day/CopyDayScheduleItemsZone')
        },
        {
          path: 'default',
          name: 'DefaultScheduler',
          component: () => import('./views/Scheduler/Default/Index')
        },
        {
          path: 'calendar',
          name: 'CalendarScheduler',
          component: () => import('./views/Scheduler/Calendar/Index')
        },
        {
          path: 'calendar/add_exception_range',
          name: 'AddExceptionRange',
          component: () => import('./views/Scheduler/Calendar/AddExceptionRange')
        },
        {
          path: 'calendar/remove_exception_range',
          name: 'RemoveExceptionRange',
          component: () => import('./views/Scheduler/Calendar/RemoveExceptionRange')
        },
        {
          path: 'calendar/date/:date',
          name: 'DateOptions',
          props: true,
          component: () => import('./views/Scheduler/Calendar/DateOptions')
        }
      ]
    },
    {
      path: '/zone/manager',
      name: 'ZoneManager',
      component: () => import('./views/Zone/Manager/Index')
    },
    {
      path: '/zone/manager/add',
      name: 'ZoneManagerAdd',
      component: () => import('./views/Zone/Manager/Add')
    },
    {
      path: '/zone/manager/edit/:zone_id',
      name: 'ZoneManagerEdit',
      props: true,
      component: () => import('./views/Zone/Manager/Edit')
    },
    {
      path: '/zone/manage/assign/devices/:zone_id',
      name: 'ZoneManagerAssignDevices',
      props: true,
      component: () => import('./views/Zone/Manager/AssignDevices')
    },
    {
      path: '/zone/manage/assign/zones/:zone_id',
      name: 'ZoneManagerAssignZones',
      props: true,
      component: () => import('./views/Zone/Manager/AssignZones')
    },
    {
      path: '/zone/map',
      name: 'ZoneMap',
      component: () => import('./views/Zone/Map/Index')
    },
    {
      path: '/devices',
      name: 'Devices',
      component: () => import('./views/Devices/Index')
    },
    {
      path: '/devices/add',
      name: 'DevicesAdd',
      component: () => import('./views/Devices/Add')
    },
    {
      path: '/devices/edit/:device_id',
      name: 'DevicesEdit',
      props: true,
      component: () => import('./views/Devices/Edit')
    },
    {
      path: '/devices/g2link/details/:device_id',
      name: 'DeviceDetailsG2Link',
      props: true,
      component: () => import('./views/Devices/DeviceDetailsG2Link')
    },
    {
      path: '/devices/g2speaker/details/:device_id',
      name: 'DeviceDetailsG2Speaker',
      props: true,
      component: () => import('./views/Devices/DeviceDetailsG2Speaker')
    },
    {
      path: '/sound/files',
      name: 'SoundFilesIndex',
      component: () => import('./views/Sound/Files/Index')
    },
    {
      path: '/sound/playlists',
      name: 'PlaylistsIndex',
      component: () => import('./views/Sound/Playlists/Index')
    },
    {
      path: '/sound/playlists/add',
      name: 'PlaylistsAdd',
      component: () => import('./views/Sound/Playlists/Add')
    },
    {
      path: '/sound/playlists/edit/:playlist_id',
      name: 'PlaylistsEdit',
      props: true,
      component: () => import('./views/Sound/Playlists/Edit')
    },
    {
      path: '/announcements',
      name: 'Notifications',
      component: () => import('./views/Notifications/Index')
    },
    {
      path: '/announcements/add',
      name: 'NotificationsAdd',
      component: () => import('./views/Notifications/Add')
    },
    {
      path: '/announcements/edit/:notification_id',
      name: 'NotificationsEdit',
      props: true,
      component: () => import('./views/Notifications/Edit')
    },
    {
      path: '/alerts',
      name: 'AlertIndex',
      component: () => import('./views/Alert/Index')
    },
    {
      path: '/events/add/:event_type_id',
      name: 'EventAdd',
      props: true,
      component: () => import('./views/Event/AddEvent')
    },
    {
      path: '/reset',
      name: 'Reset',
      props: true,
      component: () => import('./components/Event/Reset')
    },
    {
      path: '/events/summary/:event_id',
      name: 'EventSummary',
      props: true,
      component: () => import('./views/Event/EventSummary')
    },
    {
      path: '/events/visual/add/:event_id',
      name: 'AdvancedVisualAdd',
      props: true,
      component: () => import('./components/Event/Visual/AddAdvanced')
    },
    {
      path: '/events/visual/edit/:event_id/:advanced_visual_id',
      name: 'AdvancedVisualEdit',
      props: true,
      component: () => import('./components/Event/Visual/EditAdvanced')
    },
    {
      path: '/images',
      name: 'ImageGallery',
      component: () => import('./views/Gallery/Image/Index')
    },
    {
      path: '/admin',
      component: () => import('./views/Administration/Index'),
      children: [
        {
          path: 'dashboard',
          name: 'AdminDashboard',
          component: () => import('./views/Administration/Dashboard')
        },
        {
          path: 'log',
          name: 'LogIndex',
          component: () => import('./views/Administration/Log/Index')
        },
        {
          path: 'audit',
          name: 'AuditIndex',
          component: () => import('./views/Administration/Audit/Index')

        },
        {
          path: 'map',
          name: 'AdminMapIndex',
          component: () => import('./views/Administration/ZoneMap/Map/Index')
        },
        {
          path: 'map/add',
          name: 'AdminMapAdd',
          component: () => import('./views/Administration/ZoneMap/Map/Add')
        },
        {
          path: 'map/zoneException',
          name: 'AdminZoneExceptionIndex',
          component: () => import('./views/Administration/ZoneMap/ZoneException/Index')
        },
        {
          path: 'g2secure',
          name: 'AdminG2Secure',
          component: () => import('./views/Administration/G2Secure/Index')
        },
        {
          path: 'g2secure/havenlock/authcallback',
          name: 'HavenLockAuthCallback',
          component: () => import('./views/Administration/G2Secure/HavenLockAuthCallback')
        },
        {
          path: 'intercom',
          component: () => import('./views/Administration/Intercom/Index'),
          children: [
            {
              path: 'commands',
              name: 'AdminIntercomCommands',
              component: () => import('./views/Administration/Intercom/Commands')
            },
            {
              path: 'external_sip',
              name: 'AdminExternalSipIndex',
              component: () => import('./views/Administration/Intercom/ExternalSIP/Index')
            },
            {
              path: 'external_sip/add',
              name: 'AdminExternalSipAdd',
              component: () => import('./views/Administration/Intercom/ExternalSIP/Add')
            },
            {
              path: 'external_sip/edit/:intercom_external_sip_id',
              name: 'AdminExternalSipEdit',
              props: true,
              component: () => import('./views/Administration/Intercom/ExternalSIP/Edit')
            },
            {
              path: 'dialplan/public',
              name: 'AdminDialplanPublic',
              component: () => import('./views/Administration/Intercom/DialPlan/Public')
            },
            {
              path: 'dialplan/default',
              name: 'AdminDialplanDefault',
              component: () => import('./views/Administration/Intercom/DialPlan/Default')
            },
            {
              path: 'sip_profiles/internal',
              name: 'AdminSIPProfileInternal',
              component: () => import('./views/Administration/Intercom/SIPProfiles/Internal')
            },
            {
              path: 'sip_profiles/external',
              name: 'AdminSIPProfileExternal',
              component: () => import('./views/Administration/Intercom/SIPProfiles/External')
            },
            {
              path: 'vars',
              name: 'AdminIntercomVars',
              component: () => import('./views/Administration/Intercom/Vars')
            }
          ]
        },
        {
          path: 'import',
          name: 'AdminFileImport',
          component: () => import('./views/Administration/Import/Index')
        },
        {
          path: 'machine/power',
          name: 'AdminMachinePower',
          component: () => import('./views/Administration/Machine/Power')
        },
        {
          path: 'machine/network',
          name: 'AdminMachineNetwork',
          component: () => import('./views/Administration/Machine/Network')
        },
        {
          path: 'machine/dns',
          name: 'AdminMachineDNSIndex',
          component: () => import('./views/Administration/Machine/DNS/Index')
        },
        {
          path: 'machine/dns/add',
          name: 'AdminMachineDNSAdd',
          component: () => import('./views/Administration/Machine/DNS/Add')
        },
        {
          path: 'machine/ntp/edit',
          name: 'AdminMachineNTPEdit',
          component: () => import('./views/Administration/Machine/NTPServer/Edit')
        },
        {
          path: 'machine/time_zone',
          name: 'AdminMachineTimeZone',
          component: () => import('./views/Administration/Machine/TimeZone')
        },
        {
          path: 'machine/time_server',
          name: 'AdminMachineTimeServerIndex',
          component: () => import('./views/Administration/Machine/TimeServer/Index')
        },
        {
          path: 'machine/time_server/add',
          name: 'AdminMachineTimeServerAdd',
          component: () => import('./views/Administration/Machine/TimeServer/Add')
        },
        {
          path: 'machine/host_name',
          name: 'AdminMachineHostName',
          component: () => import('./views/Administration/Machine/HostName')
        },
        {
          path: 'machine/storage',
          name: 'AdminMachineStorage',
          component: () => import('./views/Administration/Machine/Storage')
        },
        {
          path: 'machine/server_update',
          name: 'AdminMachineUpdateServer',
          component: () => import('./views/Administration/Machine/UpdateServer')
        },
        {
          path: 'machine/tftp',
          name: 'AdminMachineTFTPIndex',
          component: () => import('./views/Administration/Machine/TFTP/Index')
        },
        {
          path: 'machine/tftp/file/edit',
          name: 'AdminMachineTFTPFileEdit',
          props: true,
          component: () => import('./views/Administration/Machine/TFTP/FileEdit')
        },
        {
          path: 'machine/firewall',
          name: 'AdminMachineFirewall',
          props: true,
          component: () => import('./views/Administration/Machine/Firewall')
        },
        {
          path: 'bar/backup/locations',
          name: 'AdminBARLocationsIndex',
          component: () => import('./views/Administration/BAR/Backup/Locations/Index')
        },
        {
          path: 'bar/backup/locations/add',
          name: 'AdminBARLocationsAdd',
          component: () => import('./views/Administration/BAR/Backup/Locations/Add')
        },
        {
          path: 'bar/backup/locations/edit/:backup_location_id',
          name: 'AdminBARLocationsEdit',
          props: true,
          component: () => import('./views/Administration/BAR/Backup/Locations/Edit')
        },
        {
          path: 'bar/backup/schedules',
          name: 'AdminBARScheduleIndex',
          component: () => import('./views/Administration/BAR/Backup/Schedule/Index')
        },
        {
          path: 'bar/backup/schedules/add',
          name: 'AdminBARScheduleAdd',
          component: () => import('./views/Administration/BAR/Backup/Schedule/Add')
        },
        {
          path: 'bar/backup/schedules/edit/:backup_schedule_id',
          name: 'AdminBARScheduleEdit',
          props: true,
          component: () => import('./views/Administration/BAR/Backup/Schedule/Edit')
        },
        {
          path: 'bar/backup/manual',
          name: 'AdminBARManualBackup',
          component: () => import('./views/Administration/BAR/Backup/ManualBackup')
        },
        {
          path: 'bar/restore',
          name: 'AdminBARRestore',
          component: () => import('./views/Administration/BAR/Restore/Index')
        },
        {
          path: 'users',
          name: 'AdminUsersIndex',
          component: () => import('./views/Administration/Users/Index')
        },
        {
          path: 'users/add',
          name: 'AdminUsersAdd',
          component: () => import('./views/Administration/Users/Add')
        },
        {
          path: 'users/edit/:user_id',
          name: 'AdminUsersEdit',
          props: true,
          component: () => import('./views/Administration/Users/Edit')
        },
        {
          path: 'users/changepassword/:user_id',
          name: 'AdminUsersChangePassword',
          props: true,
          component: () => import('./views/Administration/Users/ChangePassword')
        },
        {
          path: 'contacts',
          name: 'AdminContactsIndex',
          component: () => import('./views/Administration/Contacts/Index')
        },
        {
          path: 'contacts/add',
          name: 'AdminContactsAdd',
          component: () => import('./views/Administration/Contacts/Add')
        },
        {
          path: 'contacts/edit/:contact_id',
          name: 'AdminContactsEdit',
          props: true,
          component: () => import('./views/Administration/Contacts/Edit')
        },
        {
          path: 'barionet',
          name: 'AdminBarionetIndex',
          component: () => import('./views/Administration/Barionet/Index')
        },
        {
          path: 'barionet/add',
          name: 'AdminBarionetAdd',
          component: () => import('./views/Administration/Barionet/Add')
        },
        {
          path: 'barionet/edit/:device_id',
          name: 'AdminBarionetEdit',
          props: true,
          component: () => import('./views/Administration/Barionet/Edit')
        },
        {
          path: 'g2link/configure',
          name: 'AdminG2LinkConfigure',
          component: () => import('./views/Administration/G2Link/Configure')
        },
        {
          path: 'g2ipspeaker/configure',
          name: 'AdminG2IPSpeakerConfigure',
          component: () => import('./views/Administration/G2IPSpeaker/Configure')
        },
        {
          path: 'site',
          name: 'AdminSiteIndex',
          component: () => import('./views/Administration/Site/Index')
        },
        {
          path: 'site/add',
          name: 'AdminSiteAdd',
          component: () => import('./views/Administration/Site/Add')
        },
        {
          path: 'site/edit/:site_id',
          name: 'AdminSiteEdit',
          props: true,
          component: () => import('./views/Administration/Site/Edit')
        },
        {
          path: 'site/features/:site_id',
          name: 'AdminSiteFeatures',
          props: true,
          component: () => import('./views/Administration/Site/Features')
        },
        {
          path: 'site/manage/manage_landing_page/:site_id',
          name: 'AdminSiteManageLandingPage',
          props: true,
          component: () => import('./views/Administration/Site/ManageLandingPage')
        },
        {
          path: 'site/manage/logo/:site_id',
          name: 'AdminSiteManageLogo',
          props: true,
          component: () => import('./views/Administration/Site/ManageLogo')
        }
      ]
    },
    {
      path: '/softphone',
      name: 'Softphone',
      component: () => import('./views/SoftPhone/Index')
    }
  ],
  linkExactActiveClass: 'active'
})
